export const en = {
    'error-text': 'Unable to load the page. Please try again',
    'error-text-header': 'Page load error'
};
